import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'dark' | 'light';
export type UiLanguage = 'en' | 'pl';

interface UiState {
  theme: ThemeMode;
  language: UiLanguage;

  setTheme: (theme: ThemeMode) => void;
  toggleTheme: () => void;
  setLanguage: (language: UiLanguage) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    set => ({
      theme: 'dark',
      language: 'en',

      setTheme: theme => set({ theme }),
      toggleTheme: () => set(state => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      setLanguage: language => set({ language }),
    }),
    {
      name: 'ui-storage',
      partialize: state => ({ theme: state.theme, language: state.language }),
    }
  )
);
